import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { StatusBadge, PriceTag, evTitle } from "@/components/EventCard";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/time";
import { usePrefs } from "@/contexts/PrefsContext";
import type { AppEvent } from "@/types";

export const VenueEventsList = ({ venueId }: { venueId: string }) => {
  const { t, lang } = usePrefs();
  const [list, setList] = useState<AppEvent[]>([]);
  useEffect(() => {
    api.get(`/venues/${venueId}/events`).then((r) => setList(r.data)).catch(() => {});
  }, [venueId]);
  if (!list.length) return <p className="text-sm text-muted-foreground" data-testid="venue-no-events">{t("ev.noUpcoming")}</p>;
  return (
    <div className="grid gap-2" data-testid="venue-events-list">
      {list.map((e) => (
        <Link key={e.event_id} to={`/events/${e.event_id}`} data-testid={`venue-event-link-${e.event_id}`} className="rounded-2xl border p-3 hover:bg-accent transition-[background-color] space-y-1">
          <div className="flex items-center justify-between gap-2"><p className="font-bold text-sm truncate">{evTitle(e, lang)}</p><StatusBadge status={e.request_status} /></div>
          <p className="text-xs text-muted-foreground">{fmtDateTime(e.start_at, lang)} · <PriceTag e={e} /></p>
        </Link>
      ))}
    </div>
  );
};
